import en from "antd/locale/en_US";
import zh from "antd/locale/zh_CN";
import ja from "antd/locale/ja_JP";

if (ja.Modal) {
  ja.Modal.okText = "確認";
}
if (ja.Popconfirm) {
  ja.Popconfirm.okText = "確認";
}

export { en, zh, ja };
